module.exports = __webpack_public_path__ + "img/itlab.e32ce926.png";